const url = import.meta.env.VITE_APP_API_CHAT

function addMessage(state, data) {
    state.chatMessageList[data.id] = {
        id: data.id,
        from_me: data.from_me,
        message: data.message,
        read: data.read,
        date: data.date
    };
}

export default {
    actions: {
        fetchChat: async ({ state, commit, dispatch }) => {
            return dispatch("fetchAuth", {
                url: `${url}/security/get-chat`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "fetchChat"},
            }).then(
                result => {
                    if(result.code == 200) {
                        commit('SET_CHAT_NEW_COUNT', result.data.new)
                        commit('SET_CHAT_MESSAGE_LIST', result.data.messages)
                    }
                },
                error => {
                    throw Error(error.message)
                }
            )
        },
        fetchChatNew: async ({ state, commit, dispatch }) => {
            return dispatch("fetchAuth", {
                url: `${url}/security/get-chat`,
                option: {method: "GET", headers: {"Content-Type": "application/json"}},
                action: {name: "fetchChat"},
            }).then(
                result => {
                    if(result.code == 200) {
                        commit('SET_CHAT_NEW_COUNT', result.data.new)
                        commit('SET_CHAT_MESSAGE_LIST', result.data.messages)
                    }
                },
                error => {
                    throw Error(error.message)
                }
            )
        },
        sendChatMessage: async ({ state, commit, dispatch }, message) => {
            commit('SET_CHAT_TEMP_MESSAGE', message)
        },
    },
    mutations: {
        SET_CHAT_TEMP_MESSAGE(state, message) {
            const now = new Date();

            const day = String(now.getDate()).padStart(2, '0');
            const month = String(now.getMonth() + 1).padStart(2, '0');
            const hours = String(now.getHours()).padStart(2, '0');
            const minutes = String(now.getMinutes()).padStart(2, '0');

            state.tempMessage = {
                id: null,
                from_me: true,
                read: false,
                message: message,
                date: `${day}.${month} ${hours}:${minutes}`
            }
        },
        SET_CHAT_MESSAGE_LIST(state, list) {
            state.chatMessageList = list && Object.keys(list).length > 0 ? list : {}
        },
        SET_CHAT_NEW_COUNT(state, count) {
            state.chatNewCount = count
        },
        SOCKET_ONMESSAGE(state, message) {
            if(message.type !== undefined ) {
                if(message.type == "ms") {
                   if(message.to_id == null && state.tempMessage != null) {
                        state.tempMessage.id = message.id
                        state.tempMessage.message = message.message
                        addMessage(state, state.tempMessage)
                        state.tempMessage = null
                    } else {
                        addMessage(state, {
                            id: message.id,
                            from_me: !message.from_name,
                            message: message.message,
                            read: message.read,
                            date: message.date
                        })
                    }
                } else if(message.type == "rd") {
                    if(state.chatMessageList[message.id] !== undefined) {
                        state.chatMessageList[message.id].read = true
                    }
                }
            }
        },

    },
    state: {
        chatNewCount: 0,
        chatMessageList: {},
        tempMessage: null,
    },
    getters: {
        getChatNewCount:(state) => state.chatNewCount,
        getChatMessageList:(state) => state.chatMessageList,
    }
}